import React from 'react';
import PromoCodeWidget from "../promoCodeWidget";
import Discount from "../discount";
import { usePromotionsContext } from "../../hooks/usePromotionsContext";

const PromoCodesContainer = () => {
  const { appliedPromotionsData, availablePromoCodes } = usePromotionsContext();

  if (availablePromoCodes.length) {
    return <PromoCodeWidget/>;
  } else if (appliedPromotionsData.appliedPromotions.length === 0) {
    return <Discount />;
  }

  return null;
};

export default PromoCodesContainer;
